<template>
  <div>
    <ul class="list-group list-group-flush">
      <li class="list-group-item">
        <h6>Choose Office Types</h6>
      </li>

      <li class="list-group-item">

        <span v-on:change="toggleDLswitch">

          <switches
            theme="bootstrap"
            color="success"
            :emit-on-mount="true"
            :value="this.rootStore.toggleDL"
            label="Driver License"
          ></switches>

        </span>


        <span v-if="this.rootStore.officeDLSaturday.length > 0" class="checkboxUnderToggle">
          <input 
            @change="toggleSATURDAYswitch"
            
            type="checkbox" id="satudayDLcheckbox" v-model="this.rootStore.toggleDLSaturday" />
          <label for="satudayDLcheckbox">Saturday hours</label>
        </span>

        <span v-if="this.rootStore.officeKAllKiosks !== undefined && this.rootStore.officeKAllKiosks.length > 0" class="checkboxUnderToggle">
          <input 
            @change="toggleKIOSKswitchDL"
               
            type="checkbox" id="kioskDLcheckbox" v-model="this.rootStore.toggleKioskDL" />
          <label for="kioskDLcheckbox">Include kiosks</label>
        </span>

      </li>

   

      <li class="list-group-item">
        <span v-on:change="toggleLPAswitch">
        <switches
          theme="bootstrap"
          color="success"
          :emit-on-mount="true"
          :value="this.rootStore.toggleLPA"
          label="Plate &amp; Vehicle"
        ></switches>
        </span>

        <span v-if="this.rootStore.officeKAllKiosks !== undefined && this.rootStore.officeKAllKiosks.length > 0" class="checkboxUnderToggle">
          <input 
            @change="toggleKIOSKswitchLPA"
               
            type="checkbox" id="kioskLPAcheckbox" v-model="this.rootStore.toggleKioskVR" />
          <label for="kioskLPAcheckbox">Include kiosks</label>
        </span>


      </li>

      <li class="list-group-item" v-on:change="toggleLTswitch">
        <switches
          theme="bootstrap"
          color="success"
          :emit-on-mount="true"
          :value="this.rootStore.toggleLT"
          label="License &amp; Theft Bureau"
        ></switches>
      </li>

      <li class="list-group-item" v-on:change="toggleIRPswitch">
        <switches
          theme="bootstrap"
          color="success"
          :emit-on-mount="true"
          :value="this.rootStore.toggleIRP"
          label="Commercial Trucking (IRP)"
        ></switches>
      </li>
      
    </ul>
    
    <div class="col" id="settingsToggle">
      <div class="row">
        <div class="col-12">
          <span class="list-group-item checkboxInput">
            <input @change="toggleCLOSEDswitch" type="checkbox" id="settingsClosedcheckbox" v-model="this.rootStore.toggleClosed" />
            <label for="settingsClosedcheckbox">Closed temporarily</label>
          </span>
        </div>
      </div>
    </div>


  </div>
</template>





<script>
import { useRootStore } from "../store";
import Switches from "vue-switches";

export default {
  name: "SideBar",
  components: {
    Switches,
  },
  data() {
    return {
      rootStore: useRootStore()
    }
  },
  methods: {

    toggleDLswitch: function (event) {
      this.rootStore.clearClosedOfficeMode();
      this.rootStore.SET_PRIMARY_CARD([]); // Clears out the primary card
      this.rootStore.TOGGLE_SWITCH_DL(event.target.checked); // Signals to Vuex that the status has changed.
    },

    toggleLPAswitch: function (event) {
      this.rootStore.clearClosedOfficeMode();
      this.rootStore.SET_PRIMARY_CARD([]);
      this.rootStore.TOGGLE_SWITCH_LPA(event.target.checked);
    },

     toggleLTswitch: function (event) {
      this.rootStore.clearClosedOfficeMode();
      this.rootStore.SET_PRIMARY_CARD([]);
      this.rootStore.TOGGLE_SWITCH_LT(event.target.checked);
    },
    toggleIRPswitch: function (event) {
      this.rootStore.clearClosedOfficeMode();
      this.rootStore.SET_PRIMARY_CARD([]);
      this.rootStore.TOGGLE_SWITCH_IRP(event.target.checked);
    },
    
    toggleCLOSEDswitch: function (event) {
      this.rootStore.clearClosedOfficeMode();
      this.rootStore.TOGGLE_SWITCH_CLOSED(event.target.checked);
    },

    toggleSATURDAYswitch:function(event){
      this.rootStore.clearClosedOfficeMode();
      this.rootStore.TOGGLE_SWITCH_DL_SATURDAY(event.target.checked);
    },

    toggleKIOSKswitchDL(event){
      this.rootStore.clearClosedOfficeMode();
      this.rootStore.TOGGLE_SWITCH_KIOSK_DL(event.target.checked); // 
    },

    toggleKIOSKswitchLPA(event){
      this.rootStore.clearClosedOfficeMode();
      this.rootStore.TOGGLE_SWITCH_KIOSK_VR(event.target.checked);
    },

  },
watch: {

  },
  computed: {
    

  },
};

</script>